import React from 'react'
import styled from 'styled-components'

import { OutlineButton, CloseButton } from '../buttons/Buttons'
import { palette, fonts } from '../../styles/variables'
import { translate } from '../../utils/translation'
import { sendMessage } from '../../utils/functions'
import GoogleSignIn from '../buttons/GoogleSignIn'
import { LoadingResponsive } from '../loading/Loading'
import { Text } from '../topography'
import {
  kissmetricsRecordingEvent,
  KISSMETRICS_TRACK_EVENTS,
  PROPERTY_NAMES,
  PROPERTY_VALUES,
} from '../../utils/kissmetrics'
import { getUserFreeTrialDays } from '../../utils/userAuth'
import { Mixpanel } from '../../utils/mixpanel'

import Modal, { ModalHeader, ModalContent, ModalFooter } from './Modal'

const desktopStyle = {}

const mobileStyle = {
  width: '100%',
  height: 'auto',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-around',
}

const Center = styled.div({
  width: '100%',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  flexDirection: 'column',
})

export default ({
  title,
  message,
  optionalMessage,
  onAccept,
  onDeny,
  isOpen,
  hideFooter,
  renderFooter,
  showUpgrade,
  showGetAccess,
  upgradeButtonLabel,
  buttonType,
  redirectURL,
  onClose,
  isLoading,
  ...rest
}) => {
  const confirmButtonText = translate(buttonType ? 'confirm_button' : 'yes')
  return (
    <Modal
      testId="confirmation-modal"
      isOpen={isOpen}
      desktopStyle={desktopStyle}
      mobileStyle={mobileStyle}
      {...rest}
    >
      <ModalHeader data-testid="confirmation-modal-header">
        <Text
          fontSize="24px"
          mobileFontSize="22px"
          lineHeight="24px"
          fontFamily={fonts.primaryBook}
          textAlign="center"
          dangerouslySetInnerHTML={{
            __html: title,
          }}
        />
        {onClose && (
          <CloseButton
            data-testid="confirmation-modal-close-button"
            onClick={onClose}
            styles={{ top: '20px' }}
          />
        )}
      </ModalHeader>
      <ModalContent
        data-testid="confirmation-modal-content"
        style={{ height: 'calc(100% - 200px)' }}
      >
        <Text
          fontSize="14px"
          lineHeight="26px"
          fontFamily={fonts.primaryBook}
          textAlign="center"
          dangerouslySetInnerHTML={{
            __html: message,
          }}
        />
        {optionalMessage && (
          <Text
            fontSize="14px"
            lineHeight="26px"
            fontFamily={fonts.primaryBook}
            textAlign="center"
            dangerouslySetInnerHTML={{
              __html: optionalMessage,
            }}
          />
        )}
        {showUpgrade && (
          <Center>
            <GoogleSignIn
              useClickEvent
              redirectURL={redirectURL}
              hideIcon
              label={
                upgradeButtonLabel ||
                translate('seven_day_free', getUserFreeTrialDays())
              }
              height="42px"
              theme="dark"
              onClick={() => {
                if (onClose) onClose()
                if (redirectURL === '/register') {
                  Mixpanel.saveRegisterClickPageName()
                  kissmetricsRecordingEvent(
                    KISSMETRICS_TRACK_EVENTS.clicked_register,
                    {
                      [PROPERTY_NAMES.register_btn_location]:
                        PROPERTY_VALUES.register_btn.project_creation,
                    },
                  )
                }
              }}
              mobileStretch
            />
            <Text
              fontSize="12px"
              fontFamily={fonts.primaryLight}
              color={palette.darkGray50}
              margin="20px 0 0 0"
            >
              {translate('already_member')}
              <Text
                onClick={() => {
                  kissmetricsRecordingEvent(
                    KISSMETRICS_TRACK_EVENTS.clicked_signin,
                    {
                      [PROPERTY_NAMES.signin_location]:
                        PROPERTY_VALUES.signin_location.project_creation,
                    },
                  )
                  if (onClose) onClose()
                  sendMessage('SHOW_AUTH')
                }}
                style={{
                  marginLeft: '5px',
                  fontSize: '12px',
                  color: palette.orange,
                  display: 'inline-block',
                  cursor: 'pointer',
                }}
              >
                {translate('sign_in')}
              </Text>
            </Text>
          </Center>
        )}
        {showGetAccess && (
          <Center>
            <OutlineButton static onClick={onAccept}>
              {translate('chat_modal_button')}
            </OutlineButton>
          </Center>
        )}
      </ModalContent>
      {!hideFooter &&
        (renderFooter ? (
          <ModalFooter
            style={{ display: 'flex', justifyContent: 'center' }}
            data-testid="confirmation-modal-footer"
          >
            {renderFooter()}
          </ModalFooter>
        ) : (
          <ModalFooter style={{ display: 'flex', justifyContent: 'center' }}>
            <OutlineButton
              data-testid="confirmation-modal-cancel-button"
              static
              color={palette.darkGray50}
              onClick={onDeny}
            >
              {buttonType ? translate('cancel') : translate('no_aff')}
            </OutlineButton>
            <OutlineButton
              data-testid="confirmation-modal-accept-button"
              static
              onClick={onAccept}
              style={isLoading ? { padding: 5 } : {}}
            >
              {isLoading ? (
                <LoadingResponsive
                  size="30px"
                  height="42px"
                  offsetY="5%"
                  color={palette.orange}
                />
              ) : (
                confirmButtonText
              )}
            </OutlineButton>
          </ModalFooter>
        ))}
    </Modal>
  )
}
